/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PollOption } from './PollOption';
import type { PollRun } from './PollRun';
export type PollQuestionHistory = {
    questionId?: string;
    question?: string;
    qtype?: PollQuestionHistory.qtype;
    options?: Array<PollOption>;
    runs?: Array<PollRun>;
};
export namespace PollQuestionHistory {
    export enum qtype {
        SINGLE = 'single',
        MULTI = 'multi',
    }
}

